import { useQuery } from '@tanstack/react-query';
import { useSession } from '@/app/providers';
import { api, type Prices } from '@/services/api';

/** Localized prices from GET /api/prices (Stripe catalogue, 10 min cache on both sides). */
export function usePaywallPrices(override?: Prices) {
  const { locale } = useSession();
  const query = useQuery({ queryKey: ['paywall-prices', locale], queryFn: () => api.prices(locale), staleTime: 10 * 60_000, retry: 1, enabled: !override });
  return override ? { ...query, data: override, isPending: false, isError: false } : query;
}
